import { GradeUnitDayDTO } from '@app/infrastructure/models/grade-unit/grade-unit-day';
import { NotificationService } from '../notification.service';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  DayBlockDTO,
  IDayBlockDTO,
} from '@app/infrastructure/models/day-block';
import { GradeUnitDTO } from '@app/infrastructure/models/grade-unit/grade-unit';
import { HttpParams } from '@angular/common/http';
import { PageContentDTO } from '@app/infrastructure/models/page-content';

export class PageDTO {
  id: number;
  position: number;
  gradeUnitDayId: number;
  gradeUnitId: number;
  pageNumber: string;
  deletedAt: Date;
  contents: PageContentDTO[];
  blocks: IDayBlockDTO[];
  gradeUnit: GradeUnitDTO;
  gradeUnitDay: GradeUnitDayDTO;
}

@Injectable({
  providedIn: 'root',
})
export class DayPageService {
  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {}

  public getDayPages(
    gradeUnitDayId: number,
    assignmentId: number = null,
    classroomId: string = null,
  ): Observable<PageDTO[]> {
    let params = new HttpParams();
    if (assignmentId) {
      params = params.set('assignmentId', assignmentId);
    }
    if (classroomId) {
      params = params.set('classroomId', classroomId);
    }
    const endpoint = `${environment.apiRoute}/days/${gradeUnitDayId}/pages`;
    return this.apiService.get<PageDTO[]>(endpoint, { params });
  }

  public createDayPage(gradeUnitDayId: number): Observable<PageDTO> {
    const endpoint = `${environment.apiRoute}/days/${gradeUnitDayId}/pages`;
    return this.apiService.post<PageDTO, any>(endpoint, {}, {}).pipe(
      tap(() => {
        const message = `Page created.`;
        return this.notificationService.showSuccess([message], 1000);
      }),
    );
  }

  public getById(params: {
    gradeUnitDayId: number;
    pageId: number;
  }): Observable<PageDTO> {
    const endpoint = `${environment.apiRoute}/days/${params.gradeUnitDayId}/pages/${params.pageId}`;
    return this.apiService.get<PageDTO>(endpoint, {});
  }

  public deleteDayPage(
    gradeUnitDayId: number,
    pageId: number,
  ): Observable<PageDTO> {
    const endpoint = `${environment.apiRoute}/days/${gradeUnitDayId}/pages/${pageId}`;
    return this.apiService.delete<PageDTO>(endpoint).pipe(
      tap(() => {
        const message = `Page deleted.`;
        return this.notificationService.showSuccess([message], 1000);
      }),
    );
  }
}
